import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Image,
  Slider,
  Text,
} from '@fairfashion/design-system'
import parse from 'html-react-parser'

import { HeaderInformationItem } from '../../../../components/HeaderInformationItem/header-information-item.comp'
import { isQRCodeFilled } from '../../../QRCode/qrcode.utils'
import { QRCodeDetailsContext } from '../../qrcode-details.context'
import * as QRCodeDetailsStyles from '../../qrcode-details.styles'
import { QRCodeDetailsProductFormModal } from '../QRCodeDetailsProductFormModal/qrcode-details-product-form-modal.comp'

import * as Styles from './qrcode-details-header.styles'

export const QRCodeDetailsHeader = () => {
  const [editProductModalIsOpen, setEditProductModalIsOpen] = useState(false)

  const { qrcode, actions } = useContext(QRCodeDetailsContext)

  useEffect(() => {
    actions.getFinishedItemCategories()
  }, [])

  return (
    <QRCodeDetailsStyles.Card gap={2} direction="column">
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight={500}>{qrcode?.finishedItemProfile?.name}</Text>
        <Button
          padding="10px 14px"
          onClick={() => setEditProductModalIsOpen(true)}
        >
          <Icon name="edit" color="white" />
          <Text color="white" size="small" fontWeight={500}>
            Editar
          </Text>
        </Button>
      </Box>
      <Box width="100%" gap={3} flexWrap="wrap">
        <Box width="230px">
          {qrcode?.finishedItemProfile?.images?.length ? (
            <Slider buttonPosition="bottom" sizeToScroll={230}>
              {qrcode?.finishedItemProfile?.images?.map((image, index) => (
                <Styles.ImageContainer>
                  <Image
                    key={`image-${index}`}
                    width="230px"
                    height="230px"
                    alt="Product Image"
                    objectFit="cover"
                    src={image}
                  />
                </Styles.ImageContainer>
              ))}
            </Slider>
          ) : (
            <Styles.ImageContainer>
              <Image
                width="230px"
                height="230px"
                alt="Product Image"
                objectFit="cover"
                src={'/assets/default-image.png'}
              />
            </Styles.ImageContainer>
          )}
        </Box>

        <Box flex={1} direction="column" gap={2} minWidth="230px">
          <Box gap={1} alignItems="center" width="100%">
            <Text color="grey_3" size="small">
              Código SKU:
            </Text>
            <Text fontWeight={500}>{qrcode?.code}</Text>
          </Box>
          <Box width="100%">
            <Text size="small" color="grey_3">
              {parse(qrcode?.finishedItemProfile?.description || '')}
            </Text>
          </Box>
          <QRCodeDetailsStyles.InformationContainer
            width="100%"
            justifyContent="space-between"
            gap={2}
          >
            <HeaderInformationItem
              icon="survey"
              iconColor="primary"
              label="Categoria"
              value={qrcode?.finishedItemProfile?.finishedItemCategory?.name}
            />
            <HeaderInformationItem
              icon="route"
              iconColor="purple"
              label="Jornada"
              value={
                !qrcode || !isQRCodeFilled(qrcode) ? (
                  <QRCodeDetailsStyles.TagContainer status="pending">
                    Incompleta
                  </QRCodeDetailsStyles.TagContainer>
                ) : (
                  <QRCodeDetailsStyles.TagContainer status="complete">
                    Completa
                  </QRCodeDetailsStyles.TagContainer>
                )
              }
            />
            <HeaderInformationItem
              icon="checkbox_circle_line"
              iconColor="secondary"
              label="Status"
              value={
                !qrcode || !qrcode.finishedItemProfile?.qrcodeAccess ? (
                  <QRCodeDetailsStyles.TagContainer status="pending">
                    Inativo
                  </QRCodeDetailsStyles.TagContainer>
                ) : (
                  <QRCodeDetailsStyles.TagContainer status="complete">
                    Ativo
                  </QRCodeDetailsStyles.TagContainer>
                )
              }
            />
            <HeaderInformationItem
              icon="qr_code"
              iconColor="light_blue"
              label="Acessos"
              value={`${qrcode?.finishedItemStatistics?.accessCount ?? 0} acessos`}
            />
          </QRCodeDetailsStyles.InformationContainer>
        </Box>
      </Box>
      <QRCodeDetailsProductFormModal
        open={editProductModalIsOpen}
        onClose={() => setEditProductModalIsOpen(false)}
      />
    </QRCodeDetailsStyles.Card>
  )
}
